<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>
<div *ngIf="hasEntitlement('MERCHANTS_ACCOUNTS_SYNC')">
  <div class="sync">
    <app-confirm-button-combo
      [baseLabel]="' SYNC '"
      (confirmSelected)="syncProfile()"
    >
    </app-confirm-button-combo>
  </div>
</div>
<div class="card card-nc" *ngIf="hasEntitlements('ALTER_ACCOUNTABLE_OFFICIAL')">
  <div class="card-heading">
    <i class="fa fa-user"></i>
    <span class="cardHeaderHeading"> ACCOUNTABLE OFFICIAL</span>
  </div>
  <div style="padding-top: 30px" class="card-body" *ngIf="!accountableOfficial">
    <form
      class=""
      *ngIf="!accountableOfficial"
      #accountableofficialSearchForm="ngForm"
      [formGroup]="accountableOfficialSearchForm"
      name="cardholdersSearchForm"
      novalidate
      angular-Validator
    >
      <div class="form-group row">
        <div class="col-md-6">
          <input
            *ngIf="users"
            type="text"
            formControlName="firstParameter"
            [ngModel]="firstParameter"
            name="firstParameter"
            id="firstParameter"
            class="form-control input-sm searhBoxheight"
            placeholder="Please enter Cardholder name or account number."
          />
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !accountableOfficialSearchForm.get('firstParameter').valid &&
              accountableOfficialSearchForm.get('firstParameter').touched &&
              accountableOfficialSearchForm.get('firstParameter').errors
            "
          >
            Please enter at least 2 characters
          </span>
        </div>

        <div class="col-md-1">
          <button
            type="submit"
            [disabled]="!accountableOfficialSearchForm.valid"
            id="searchButton"
            (click)="submit()"
            class="form-group btn btn-nc pull-right"
          >
            SEARCH <i [ngClass]="search_btn_spinner"></i>
          </button>
          <br />
        </div>
      </div>
    </form>
  </div>
  <div class="card-body" *ngIf="accountableOfficial">
    <div class="row labelCommon text-nowrap">
      <div class="col-md-2 col-centered" style="padding-top: 7px">
        <div class="col-md-12">{{ currentAOName }}</div>
      </div>
      <div class="col-md-2 zeroPadding col-centered">
        <div class="col-md-12">
          <button
            type="submit"
            [disabled]="!accountableOfficialSearchForm.valid"
            id="resetButton"
            (click)="reset()"
            class="form-group btn btn-nc align-middle"
          >
            RESET <i [ngClass]="search_btn_spinner"></i>
          </button>
        </div>
      </div>
      <div class="col-md-2 zeroPadding col-centered"></div>
      <div class="col-md-2 zeroPadding col-centered"></div>
      <div class="col-md-4 zeroPadding col-centered"></div>
      <br />
    </div>
  </div>
</div>
<div [ngSwitch]="subview" *ngIf="hasEntitlements('ALTER_ACCOUNTABLE_OFFICIAL')">
  <div *ngSwitchCase="'spinner'">
    <div class="row">
      <div class="col-md-offset-6">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'noSearchParameters'">
    <div class="searchResults">
      <div class="row searchResultsRow">Please enter search criteria.</div>
    </div>
  </div>
  <div *ngSwitchCase="'noResults'">
    <div class="searchResults">
      <div class="row searchResultsRow">No results found.</div>
    </div>
  </div>
  <div *ngSwitchCase="'recentResults'" class="searchResults">
    <app-search-results
      (cardholderSelected)="showCardholder($event)"
      [profileSearchResults]="searchResults"
    ></app-search-results>
  </div>
  <div *ngSwitchCase="'results'" class="searchResults">
    <app-search-results
      (cardholderSelected)="showCardholder($event)"
      [profileSearchResults]="searchResults"
    ></app-search-results>
  </div>
</div>
<form name="accountForm" #accountForm="ngForm" novalidate>
  <div *ngIf="dataLoading" class="col-1">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </div>
  <!-- STRIP ACCOUNT begin -->
  <div
    class="card card-nc"
    *ngIf="
      merchantAccountInfo &&
      hasEntitlement('MERCHANTS_ACCOUNTS_STRIP') &&
      !dataLoading
    "
  >
    <!-- Default card contents -->
    <div class="card-heading">
      <i class="fa fa-credit-card"></i>
      <span class="cardHeaderHeading"> STRIP ACCOUNT: </span>&nbsp;&nbsp;
      <span class="cardHeaderVal">{{ stripAccount.account }}</span>
      <ng-container *ngIf="identity && identity.dda">
        <span style="padding-left: 40px" class="cardHeaderHeading">
          Pseudo DDA: </span
        >&nbsp;&nbsp;
        <span class="cardHeaderVal">{{ identity.dda }}</span>
      </ng-container>
      <span class="float-right save-card">
        <button
          *ngIf="hasEntitlement('MERCHANTS_ACCOUNT_STRIP_UPDATE')"
          type="submit"
          [disabled]="save_s_btn || !accountForm.valid"
          (click)="saveStripAccount()"
          class="btn btn-nc"
          [ngClass]="{ 'fa fa-spinner': save_s_btn }"
        >
          SAVE
        </button>
      </span>

      <span class="float-right subCardHeaderHeading lastPwdLabelBox">
        <div class="col-md-12" style="padding-right: 20px">Last update on</div>
        <div class="col-md-12" style="padding-right: 20px">
          {{ stripAccount.statusDate | date: "fullDate" }}
        </div>
      </span>
    </div>

    <div class="card-body">
      <div class="row labelCommon text-nowrap">
        <div class="col-md-2 zeroPadding col-centered accountBorder">
          <div class="col-md-12">Account Balance</div>
          <div class="col-md-12">
            <span class="staticText1"
              ><span class="dollerSymbolColor"
                ><i class="fa fa-usd"></i>&nbsp;</span
              >{{ stripAccount.currentBalance | currency: "" : "" }}</span
            >
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder">
          <div class="col-md-12">Hold Amount</div>
          <div class="col-md-12">
            <span class="staticText1"
              ><span class="dollerSymbolColor"
                ><i class="fa fa-usd"></i>&nbsp;</span
              >{{ stripAccount.holdAmount | currency: "" : "" }}</span
            >
          </div>
        </div>
        <div class="col-md-2 zeroPadding accountBorder">
          <div class="col-md-12">ACH Withdrawal Limit</div>
          <div
            class="form-group col-md-12"
            *ngIf="
              hasEntitlement('MERCHANTS_ACCOUNT_STRIP_UPDATE') &&
              merchantAccountInfo.merchant.merchantType === 'PVT'
            "
          >
            <span class="staticText1">
              <span class="innerFieldSymbol"><i class="fa fa-usd"></i></span>
              <input
                type="text"
                id="stripWithdrawalLimit"
                [(ngModel)]="stripAccount.withdrawalLimit"
                style="width: 95%"
                name="withdrawalLimit"
                required
                #wdlLimit="ngModel"
                class="form-control input-sm outerBox"
                pattern="^\d*\.?\d{1,2}$"
            /></span>
            <span
              *ngIf="wdlLimit.touched && wdlLimit.dirty && !wdlLimit.valid"
              class="has-error validationMessage"
              >Invalid Amount</span
            >
          </div>
          <div
            class="form-group col-md-12"
            *ngIf="
              merchantAccountInfo.merchant.merchantType != 'PVT' ||
              !hasEntitlement('MERCHANTS_ACCOUNT_STRIP_UPDATE')
            "
          >
            <span class="staticText1"
              ><span class="dollerSymbolColor"
                ><i class="fa fa-usd"></i>&nbsp;</span
              >
              {{ stripAccount.withdrawalLimit | currency: "" : "" }}</span
            >
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder">
          <div class="col-md-12">Creation Date</div>
          <div class="form-group col-md-12 staticText1">
            {{ stripAccount.openDate | date: "MM/dd/yyyy" }}
          </div>
        </div>

        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12 control-label labelCommon">Status</div>
          </div>
          <div class="row">
            <div
              class="form-group col-md-10"
              style="margin-bottom: -20px"
              *ngIf="hasEntitlement('MERCHANTS_ACCOUNT_STRIP_UPDATE')"
            >
              <select
                class="form-control input-sm"
                name="stripStatus {{ $index }}"
                id="stripStatus"
                [(ngModel)]="stripAccount.status"
              >
                <option
                  *ngFor="let stripStat of stripAccount.targetStats"
                  [ngValue]="stripStat"
                >
                  {{ stripStat }}
                </option>
              </select>
              &nbsp;&nbsp;
            </div>
            <div
              class="form-group col-md-10"
              *ngIf="!hasEntitlement('MERCHANTS_ACCOUNT_STRIP_UPDATE')"
            >
              {{ stripAccount.status }}
            </div>
            <div class="col-md-2">
              <div [ngClass]="stripAccount.status | processingStatusPipe"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- STRIP ACCOUNT end -->

  <!-- Card ACCOUNT begin -->
  <div
    *ngIf="merchantAccountInfo && hasEntitlement('MERCHANTS_ACCOUNTS_CARDS')"
  >
    <div
      class="card card-nc"
      *ngFor="let card of cardsAccount; let $index = index"
    >
      <!-- Default card contents -->
      <div class="card-heading">
        <span class="icon-NC_chip"></span
        ><span class="cardHeaderHeading"> CARD ID: </span>
        <span class="cardHeaderVal">
          {{ card.cardSeq }}
          <span class="cardHeaderVal" *ngIf="isEMV(card.closedLoopPan) == true">
            <img id="EMV-card" src="assets/img/EMV.svg" alt="" />
          </span>
        </span>
        <span class="pull-right save-card">
          <button
            *ngIf="
              hasEntitlement('MERCHANTS_ACCOUNT_CHIP_UPDATE') ||
              hasEntitlement('MERCHANTS_ACCOUNT_CARD_UPDATE')
            "
            type="submit"
            [disabled]="save_a_btn && rowIndex === $index"
            [ngClass]="{ 'fa fa-spinner': save_a_btn && rowIndex === $index }"
            (click)="
              saveAccounts(card, chipsAccount[$index], cardStatus, $index)
            "
            class="btn btn-nc"
          >
            SAVE
          </button>
        </span>
      </div>

      <div class="card-body" style="padding-bottom: 15px">
        <div class="row cardRowBackground labelCommon text-nowrap">
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Card Number</div>
            <div class="col-md-12 staticText1">*****{{ card.masterCard }}</div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Issue Date</div>
            <div class="col-md-12 staticText1">
              {{ card.issueDate | date: "MM/dd/yyyy" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Expiry Date</div>
            <div class="col-md-12 staticText1">
              {{ card.expirationDate | date: "MM/dd/yyyy" : "UTC" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder">
            <div class="col-md-12">Card Status Date</div>
            <div class="col-md-12 staticText1">
              {{ card.statusDate | date: "MM/dd/yyyy" }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="row"><div class="col-md-12">Status</div></div>
            <div class="row">
              <div
                class="form-group col-md-10"
                *ngIf="
                  (originalCardStatuses[$index] === 'ACTIVE' ||
                    originalCardStatuses[$index] === 'PENDACTIVE') &&
                  hasEntitlement('MERCHANTS_ACCOUNT_CARD_UPDATE')
                "
              >
                <select
                  class="form-control input-sm"
                  name="cardStatus{{ $index }}"
                  id="cardStatus"
                  [(ngModel)]="cardsAccount[$index].status"
                >
                  <option
                    *ngFor="let cardStat of card.targetStats"
                    [ngValue]="cardStat"
                  >
                    {{ cardStat }}
                  </option>
                </select>
              </div>
              <div
                class="form-group col-md-10 staticText1"
                *ngIf="
                  (originalCardStatuses[$index] !== 'ACTIVE' &&
                    originalCardStatuses[$index] !== 'PENDACTIVE') ||
                  !hasEntitlement('MERCHANTS_ACCOUNT_CARD_UPDATE')
                "
              >
                {{ cardsAccount[$index].status }}
              </div>
              <div class="col-md-2">
                <div
                  [ngClass]="cardsAccount[$index].status | processingStatusPipe"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CHIP ACCOUNT begin -->
      <div class="card-body">
        <div
          *ngIf="
            merchantAccountInfo && hasEntitlement('MERCHANTS_ACCOUNTS_CHIPS')
          "
        >
          <div class="row chipRowBackground labelCommon text-nowrap">
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Chip Number</div>
              <div class="col-md-12 staticText1">{{ card.chipAccount }}</div>
            </div>
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Account Balance</div>
              <div class="col-md-12">
                <span class="staticText1"
                  ><span class="dollerSymbolColor"
                    ><i class="fa fa-usd"></i></span
                  >&nbsp;{{
                    chipsAccount[$index].currentBalance | currency: "" : ""
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Open Date</div>
              <div class="col-md-12 staticText1">
                <span class="staticText1">{{
                  chipsAccount[$index].openDate | date: "MM/dd/yyyy"
                }}</span>
              </div>
            </div>
            <div class="col-md-2 zeroPadding col-centered accountBorder">
              <div class="col-md-12">Chip Status Date</div>
              <div class="col-md-12 staticText1">
                {{ chipsAccount[$index].statusDate | date: "MM/dd/yyyy" }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="row"><div class="col-md-12">Status</div></div>
              <div class="row">
                <div
                  class="form-group col-md-10"
                  *ngIf="
                    hasEntitlement('MERCHANTS_ACCOUNT_CHIP_UPDATE') &&
                    (originalCardStatuses[$index] === 'ACTIVE' ||
                      originalChipStatuses[$index] === 'OPEN')
                  "
                >
                  <select
                    class="form-control input-sm"
                    name="chipStat{{ $index }}"
                    id="chipStat"
                    [(ngModel)]="chipsAccount[$index].status"
                  >
                    <option
                      *ngFor="let chipStat of chipsAccount[$index].targetStats"
                      [ngValue]="chipStat"
                    >
                      {{ chipStat }}
                    </option>
                  </select>
                </div>
                <div
                  class="form-group col-md-10 staticText1"
                  *ngIf="
                    !hasEntitlement('MERCHANTS_ACCOUNT_CHIP_UPDATE') ||
                    (originalCardStatuses[$index] !== 'ACTIVE' &&
                      originalChipStatuses[$index] !== 'OPEN')
                  "
                >
                  {{ chipsAccount[$index].status }}
                </div>
                <div class="col-md-2">
                  <div
                    [ngClass]="
                      chipsAccount[$index].status | processingStatusPipe
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="rowThinBorder"></div>
          <div class="row chipRowBackground labelCommon text-nowrap">
            <div
              class="col-md-2 accountBorder form-group"
              *ngIf="hasEntitlement('MERCHANTS_ACCOUNT_CHIP_UPDATE')"
            >
              <div class="col-md-12 col-centered">Chip Limit</div>
              <div class="col-md-12">
                <span class="staticText1"
                  ><span class="innerFieldSymbol"
                    ><i class="fa fa-usd"></i></span
                  >&nbsp;
                  <input
                    type="text"
                    id="chipLimit"
                    [(ngModel)]="card.chipLimit"
                    name="chipLimit{{ $index }}"
                    style="width: 80%"
                    validator="chipLimitValidator(card.chipLimit)==true"
                    required
                    class="form-control input-sm outerBox"
                /></span>
              </div>
            </div>
            <div
              class="col-md-2 accountBorder col-centered form-group"
              *ngIf="!hasEntitlement('MERCHANTS_ACCOUNT_CHIP_UPDATE')"
            >
              <div class="col-md-12">Chip Limit</div>
              <div class="col-md-12">
                <span class="staticText1"
                  ><span class="dollerSymbolColor"
                    ><i class="fa fa-usd"></i></span
                  >&nbsp;{{ card.chipLimit | currency: "" : "" }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- CHIP ACCOUNT end -->
    </div>
  </div>
  <!-- Card ACCOUNT end -->
</form>
